import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { IAppealsListApi } from '../models/appeals-api.model';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { IAppealSubmitRequest, IAppealSubmitResponse, IAppealSubmitted } from '../models/api/appeal-submit-request.model';
import { mapAppealRequestToForm } from '../models/api/appeal.mapper';
import { IAppealsDraftForm } from '../models/appeal.model';
import { map } from 'rxjs/operators';
import { AdvancedSearchCheckboxes, AdvancedSearchConfigResponse, AdvancedSearchOption } from '@carm/shared/components/advanced-search/models/advanced-search.model';
import { LoaderSpinnerTypes } from '@carm/_core/models/loader-types.model';

@Injectable()
export class AppealsService extends BaseApiService {
  constructor(protected injector: Injector, private datePipe: DatePipe) {
    super(injector);
  }

  private get serviceBaseUrlBP(): string {
    return this.endPointBP;
  }

  public getAppealsList(
    type: 'appeals' | 'penalty-appeals',
    minDate: Date,
    maxDate: Date,
    sort: string,
    pageIndex: number,
    pageSize: number,
    searchString: string
  ): Observable<IAppealsListApi> {
    const params = new HttpParams()
      .set('currentPage', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('sort', sort)
      .set('searchString', searchString || null)
      .set('startDate', this.datePipe.transform(minDate, 'yyyy-MM-dd'))
      .set('endDate', this.datePipe.transform(maxDate, 'yyyy-MM-dd'));

    const endPoint = `${this.serviceBaseUrlBP}/${type}/list`;
    return this.httpAuthGet<IAppealsListApi>(endPoint, params, LoaderSpinnerTypes.AgGrid);
  }

  public submitAppeal(
    request: IAppealSubmitRequest
  ): Observable<IAppealSubmitResponse> {
    const endpoint = `${this.endPointBP}/appeals/submit`;
    return this.httpAuthPost<IAppealSubmitResponse>(endpoint, request);
  }

  public getAppeal(caseNumber: string): Observable<IAppealsDraftForm> {
    const endpoint = `${this.endPointBP}/appeals/view/${caseNumber}`;

    return this.httpAuthGet<IAppealSubmitted>(endpoint).pipe(
      map(response => mapAppealRequestToForm(response))
    );
  }

  getAppealsSearchOptions(type: 'appeals' | 'penalty-appeals'): Observable<AdvancedSearchConfigResponse> {
    const endPoint = `${this.serviceBaseUrlBP}/${type}/search-options`;
    return this.httpAuthGet<AdvancedSearchConfigResponse>(endPoint).pipe(
      map((advanceSearch: AdvancedSearchConfigResponse) => {
        return {
          searchOptions: advanceSearch.searchOptions?.map(
            (advanceSearchOption: AdvancedSearchOption) => {
              advanceSearchOption.key = advanceSearchOption.value; // api return number for key. use identifier
              advanceSearchOption.value = this.translateService.instant(
                `concepts.rulings.advanceSearchOptions.${advanceSearchOption.value}`
              );
              return advanceSearchOption;
            }
          ),
          checkboxes: advanceSearch.checkboxes?.map(
            (checkboxes: AdvancedSearchCheckboxes) => {
              checkboxes.value = this.translateService.instant(
                `concepts.rulings.advanceSearchOptions.${checkboxes.value}`
              );
              return checkboxes;
            }
          ),
        } as AdvancedSearchConfigResponse;
      })
    );
  }

}
